export function stripeKey() {
  return process.env.REACT_APP_STRIPE_KEY as string;
}
